import {ModalContext} from "app/app";
import {Fragment, useContext, useEffect, useState} from "react";
import styles from "./styles.module.scss";
import axios from "axios";
import {ViewContext} from "components/lib";
import {useNavigate} from "react-router-dom";

export function RenewalStatusModal() {
  const {modal, setModal} = useContext(ModalContext);
  const navigate = useNavigate();
  const context = useContext(ViewContext);
  const statusOptions = ['Active', 'Declined', 'Expired', 'Bound', 'Permanently Delete'];
  const [sending, setSending] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState('');

  useEffect(() => {
    if (modal.name === "renewal_status_modal") {
      setSelectedStatus('');
    }
  }, [modal.name]);

  const handleCancel = () => {
    setModal("");
  };

  const handleConfirm = async () => {
    if (!selectedStatus) {
      context.notification.show(
        "Please select a status before confirming.",
        "warning",
        true,
        "toast",
        "exclamation-circle"
      );
      return;
    }

    setSending(true);
    try {
      const response = await axios.put(`/api/renewals/${modal.data.id}`,
        {status: selectedStatus},
        {headers: {'Content-Type': 'application/json'}}
      );

      if (response.data.success) {
        if (selectedStatus === "Permanently Delete") {
          context.notification.show(
            "Ticket deleted successfully.",
            "success",
            true,
            "toast",
            "check-circle"
          );
        } else {
          context.notification.show(
            "Ticket status updated successfully!",
            "success",
            true,
            "toast",
            "check-circle"
          );
        }
        setSending(false);
        setModal("");

        if (selectedStatus === "Permanently Delete") {
          navigate("/admin/renewal?page=1");
        }
      }
    } catch (error) {
      context.notification.show(
        "Couldn't change ticket status, please try again later.",
        "error",
        true,
        "toast",
        "times-circle"
      );
      setSending(false);
    }
  };

  return (
    <Fragment>
      {modal.name === "renewal_status_modal" && (
        <div className={styles.background}>
          <div className={styles.wrapper}>
            <div className={styles.insideWrapper}>
              <div
                style={{
                  fontStyle: "normal",
                  fontSize: 22,
                  marginBottom: 10,
                  marginLeft: 20,
                  color: "black"
                }}
              >
                Select Status
              </div>

              <div style={{marginLeft: 20, marginBottom: 20}}>
                {statusOptions.map((status) => (
                  <div key={status} style={{marginBottom: 10}}>
                    <input
                      type="radio"
                      id={status}
                      name="renewalStatus"
                      value={status}
                      checked={selectedStatus === status}
                      onChange={() => setSelectedStatus(status)}
                    />
                    <label htmlFor={status} style={{marginLeft: 8}}>
                      {status}
                    </label>
                  </div>
                ))}
              </div>

              <div className={styles.footer} style={{justifyContent: "end", paddingRight: '8px'}}>
                <div className={styles.buttons}>
                  <button className={styles.cancel} onClick={handleCancel}>
                    Cancel
                  </button>
                  <button
                    className={styles.save}
                    onClick={handleConfirm}
                    disabled={sending || !selectedStatus}
                  >
                    {sending ? "Sending..." : "Confirm"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}
